// extracted by mini-css-extract-plugin
export default {"seconds":"SessionExpiredModal-seconds","actions":"SessionExpiredModal-actions","cancel":"SessionExpiredModal-cancel"};